


























































import { Component, Vue, Mixins } from 'vue-property-decorator';
import PageInitialMixin from '@/mixins/PageInitialMixin';
import { Getter } from 'vuex-class';

import FooterLayer from '@/layers/FooterLayer.vue';
import EditFooter from '@/components/common/edit/EditFooter.vue';

// Mask层级
import MaskLayer from '@/layers/MaskLayer.vue';

// 内容层级
import ContentLayer from '@/layers/ContentLayer.vue';
import BackgroundMusic from '@/components/common/edit/BackgroundMusic.vue';
import ActivityInstPhone from '@/components/common/edit/ActivityInstPhone.vue';
import DataShow from '@/components/common/edit/DataShow.vue';
import NumShow from '@/components/common/edit/NumShow.vue';
import BarrageSwitch from '@/components/common/edit/BarrageSwitch.vue';
import SMSVerfication from '@/components/common/edit/ SMSVerification.vue';
import SignupItem from '@/components/common/edit/SignupItem.vue';
import ActivityName from '@/components/common/edit/ActivityName.vue';
import RuleIntro from '@/components/common/edit/RuleIntro.vue';
import ContactInfo from '@/components/common/edit/ContactInfo.vue';
import ActivityTitle from '@/components/common/edit/ActivityTitle.vue';
import ActivityInstName from '@/components/common/edit/ActivityInstName.vue';
import ActivityDeadline from '@/components/common/edit/ActivityDeadline.vue';
import ActivityStartTime from '@/components/common/edit/ActivityStartTime.vue';
import ActivitySection from './components/edit/ActivitySection.vue';
import InstitutionIntro from '@/components/common/edit/InstitutionIntro.vue';
import DashLine from '@/components/common/edit/DashLine.vue';
import GrayBackgroundBlock from '@/components/common/edit/GrayBackgroundBlock.vue';
import IndexRuleIntro from '@/components/common/index/IndexRuleIntro.vue';
import TitleTips from '@/components/common/edit/TitleTips.vue';
import TitleWarning from '@/components/common/edit/TitleWarning.vue';
import ActivityMainImageEdit from '@/components/common/edit/ActivityMainImageEdit.vue';
import SelectInst from '@/components/common/edit/SelectInst.vue';
import ActivityChoise from './components/edit/AcitvityChoise.vue';
import PotentialSwitch from '@/components/common/edit/PotentialSwitch.vue';
import ActivityLabel from '@/components/common/edit/ActivityLabel.vue';
import ActivityInstAddress from '@/components/common/edit/ActivityInstAddress.vue';
import UserAgreementModal from './components/edit/UserAgreement.vue';
import UserAgreementContentModal from './components/edit/UserAgreementContentModal.vue';
import getUrlParam from '@/common/utils/getUrlParam';
@Component({
  components: {
    'activity-label': ActivityLabel,
    'activity-main-image-edit': ActivityMainImageEdit,
    'select-inst': SelectInst,
    'footer-layer': FooterLayer,
    'edit-footer': EditFooter,
    'content-layer': ContentLayer,
    'activity-choise': ActivityChoise,
    'title-tips': TitleTips,
    'title-warning': TitleWarning,
    'activity-section': ActivitySection,
    'activity-title': ActivityTitle,
    'activity-inst-name': ActivityInstName,
    'activity-inst-address': ActivityInstAddress,
    'activity-deadline': ActivityDeadline,
    'activity-start-time': ActivityStartTime,
    'institution-intro': InstitutionIntro,
    'background-music': BackgroundMusic,
    'activity-inst-phone': ActivityInstPhone,
    'data-show': DataShow,
    'num-show': NumShow,
    'barrage-switch': BarrageSwitch,
    'sms-verfication': SMSVerfication,
    'signup-item': SignupItem,
    'activity-name': ActivityName,
    'rule-intro': RuleIntro,
    'contact-info': ContactInfo,
    'dash-line': DashLine,
    'background-block': GrayBackgroundBlock,
    'index-rule-intro': IndexRuleIntro,
    'mask-layer': MaskLayer,
    'potential-swtich': PotentialSwitch,
    'user-agreement-modal': UserAgreementModal,
    'user-agreement-content-modal': UserAgreementContentModal,
  },
})
export default class groupSolitaireEdit extends Mixins(PageInitialMixin) {
  @Getter('orgId') orgId!: string;
  @Getter('topTips') topTips!: string;
  @Getter('version') version!: string;
  @Getter('xcxFlag') xcxFlag!: boolean;
  @Getter('xmMajordomo') xmMajordomo!: boolean;
  @Getter('mainBackgroundColor') mainBackgroundColor!: boolean;
  @Getter('gachaTypeParameter') gachaTypeParameter!: object;
  isCopy: boolean = false;
  isFromDistribute: boolean = true;

  created() {
    const isCopy = getUrlParam('state') == 'copy';
    this.isCopy = isCopy;
  }
  mounted() {
    window.addEventListener('touchmove', this.hiddenKeyboard);
  }
  hiddenKeyboard(evt: Event): void {
    (document.activeElement as HTMLElement).blur();
  }
}
